import { render } from "./UserCard.vue?vue&type=template&id=10da2275&scoped=true"
import script from "./UserCard.vue?vue&type=script&lang=ts"
export * from "./UserCard.vue?vue&type=script&lang=ts"

import "./UserCard.vue?vue&type=style&index=0&id=10da2275&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10da2275"

export default script